<template>
  <div class="BaseCheckboxesList base-checkboxes-list">
    <slot name="prepend"></slot>
    <BaseCheckbox
      v-for="(item, index) in list"
      :key="index"
      :color="color"
      :label="$get(item, labelKey)"
      :checked="isCheckedInCheckboxesList(value, item)"
      @input="bindWithCheckboxesList(value, $event, item)"
    />
    <slot name="append"></slot>
  </div>
</template>

<script>
export default {
  name: 'CheckboxesList',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    itemId: {
      type: String,
      default: 'id',
    },
    labelKey: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
  },
  methods: {
    bindWithCheckboxesList(list, checked, value) {
      if (checked) this.$emit('input', [...list, value]);
      else {
        const listModified = [...list];
        const idx = listModified.findIndex(el => this.$get(el, this.itemId) === this.$get(value, this.itemId));
        listModified.splice(idx, 1);
        this.$emit('input', listModified);
      }
    },
    isCheckedInCheckboxesList(list, value) {
      return !!list.find(el => this.$get(el, this.itemId) === this.$get(value, this.itemId));
    },
  },
};
</script>

<style lang="less">
  .base-checkboxes-list {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;

    label {
      width: max-content;
      max-width: 100%;
    }

    span.checkbox__mark {
      border-radius: 0.3rem;
    }

    span.checkbox__text {
      margin-top: 0.2rem;
      font-size: 1.2rem;
      color: black;
    }
  }
</style>
